/**
 * Detects website navigation / footer / template text that a scraper picked up
 * instead of product copy (e.g. Sigma's "Corporate Overview", "Buy from
 * reseller", stray `-->` from HTML comments). Such text must never count as a
 * description or feature when judging whether a staged product can be approved.
 *
 * Keep aligned with `src/utils/siteChromeText.ts`.
 */

export const SITE_CHROME_PATTERNS: readonly RegExp[] = [
  /corporate\s+overview/i,
  /buy\s+from\s+(a\s+)?reseller/i,
  /world\s+network/i,
  /find\s+an?\s+(?:[\w&'-]+\s+){0,3}dealer/i,
  /skip\s+to\s+(main\s+)?content/i,
  /-->/,
  /<!--/,
];

/** True when the text contains site-menu / footer / comment-marker residue. */
export function looksLikeSiteChrome(text: unknown): boolean {
  if (typeof text !== 'string') return false;
  const t = text.trim();
  if (!t) return false;
  return SITE_CHROME_PATTERNS.some((re) => re.test(t));
}
